import styled from 'styled-components';

import Input from '@components/Input';
import Button from '@components/Button/next';

export const StyledNameFilter = styled.div`
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  & > * {
    box-sizing: border-box;
  }

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 12px;
  }
`;

export const NameFilterTitle = styled.h3`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.NL800};
`;

export const FilterHotelNameLabel = styled.span`
  display: block;
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGray};
`;

export const NameFilterInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL10};

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border: solid 1px ${({ theme }) => theme.palette.inputBorderColor};

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const InputButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 54px;
  gap: 4px;
  grid-template-rows: 44px;
  margin-top: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
  }
`;
export const NameFilterInput = styled(Input)`
  width: 100%;
  height: 100% !important;
  padding: 0;
  background-color: transparent;
  border-color: transparent;
  outline: none;
  font-size: 16px;
  font-weight: 400;
  caret-color: ${({ theme }) => theme.palette.NL500};
  color: ${({ theme }) => theme.palette.NL500};
  background-color: ${({ theme }) => theme.palette.NL10};
  border: none;
  &:focus-within,
  &:focus {
    border: none !important;
    outline: 0;
  }
`;

export const ClearContainer = styled.div`
  display: flex;
  color: ${(p) => p.theme.palette.tomato};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: #f06256;
  gap: 4px;
  cursor: pointer;
`;

export const NameFilterSearchButton = styled(Button)`
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.palette.R600};
  font-weight: 900;
  font-size: 14px;
  border: solid 1px ${({ theme }) => theme.palette.R600};
  border-radius: 8px;

  &:disabled {
    opacity: 0.5;
  }
`;

NameFilterSearchButton.defaultProps = {
  outline: true,
};

export const CollapsableStyledNameFilter = styled(StyledNameFilter)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 12px 12px 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const CollapsableNameFilterInputWrapper = styled(NameFilterInputWrapper)`
  margin-top: 0;
`;
